module.exports = __webpack_public_path__ + "static/profil.82403617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profil.png
// module id = 545
// module chunks = 168707334958949